import {
	INITIAL_INVENTORY_REQUEST,
	FINAL_INVENTORY_REQUEST,
	FETCH_INVENTORY_SUCCESS,
	UPDATE_INVENTORIES,
	CHANGE_TAGS_AVAILABLE,
} from "../types/inventory.types";
import { UPDATE_NOTIFICATIONS } from "../types/auth.types";

import InventoryService from "@/services/inventory.service";

export const fetchInventories = (form) => (dispatch) => {
	dispatch({ type: INITIAL_INVENTORY_REQUEST });

	return InventoryService.getInventories(form)
		.then((response) => {
			dispatch({
				type: FETCH_INVENTORY_SUCCESS,
				payload: {
					inventories: response.data.inventories.data,
					products: response.data.products,
					aptitudes: response.data.aptitudes,
					active_ingredients: response.data.active_ingredients,
					cas: response.data.cas,
					formulas: response.data.formulas,
					dealers: response.data.dealers,
					business: response.data.business,
					quantity: response.data.inventories.total,
					last_page: response.data.inventories.last_page,
					from: response.data.inventories.from,
					to: response.data.inventories.to,
					permissions: response.data.permissions,
				},
			});

			dispatch({
				type: CHANGE_TAGS_AVAILABLE,
				payload: {
					tags_available: response.data.tags_available,
					lots_available: response.data.lots_available,
				},
			});

			dispatch({
				type: UPDATE_NOTIFICATIONS,
				payload: {
					notifications: response.data.notifications,
				},
			});

			return Promise.resolve(response.data);
		})
		.catch((_error) => {
			dispatch({ type: FINAL_INVENTORY_REQUEST });
			return Promise.resolve(null);
		});
};

export const updateInventories = (inventories) => (dispatch) => {
	dispatch({
		type: UPDATE_INVENTORIES,
		payload: {
			inventories: inventories,
		},
	});
};

export const createInventoriesFromTags = (inventories, search, parameter, page, paginate, defaultUnit, estate_id, typeCurrency) => (dispatch) => {
	dispatch({
		type: INITIAL_INVENTORY_REQUEST,
		payload: {
			message: "Creando etiquetas ...",
		},
	});

	return InventoryService.createInventoriesFromTags(inventories, search, parameter, page, paginate, defaultUnit, estate_id, typeCurrency, dispatch)
		.then((response) => {
			dispatch({
				type: FETCH_INVENTORY_SUCCESS,
				payload: {
					inventories: response.data.inventories.data,
					products: response.data.products,
					aptitudes: response.data.aptitudes,
					active_ingredients: response.data.active_ingredients,
					cas: response.data.cas,
					formulas: response.data.formulas,
					dealers: response.data.dealers,
					business: response.data.business,
					quantity: response.data.inventories.total,
					last_page: response.data.inventories.last_page,
					from: response.data.inventories.from,
					to: response.data.inventories.to,
					permissions: response.data.permissions,
				},
			});

			return Promise.resolve(response.data);
		})
		.catch((_error) => {
			dispatch({ type: FINAL_INVENTORY_REQUEST });
			return Promise.resolve(null);
		});
};
